export const actionButtonBg = (theme) => {
 return  theme.mode === "info" || theme.mode === "tertiary" ? "primary" : theme.mode === "primary" ? "secondary" :  "success"
};
